import { I18n } from '@app/i18n/strings-keys';

export enum DATA_SOURCE {
  POS = 'POS',
  Portal = 'Portal',
  All_Sources = 'All Sources',
}

export enum DATA_SOURCE_VALUE {
  POS = 'POS',
  Portal = 'Portal',
  All_Sources = 'all_sources',
}

export const DATA_SOURCE_ENUM_OPTIONS = Object.freeze({
  [DATA_SOURCE_VALUE.POS]: I18n.Common.POS,
  [DATA_SOURCE_VALUE.Portal]: I18n.Common.Portal,
  [DATA_SOURCE_VALUE.All_Sources]: I18n.Common.All_Sources,
});

export const DEFAULT_DATA_SOURCE =
  DATA_SOURCE_ENUM_OPTIONS[DATA_SOURCE_VALUE.Portal];
